import React, { useEffect, useState } from 'react';
import axios from 'axios'; import BASE_API_URL from 'const';
import { Link } from 'react-router-dom';
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

function PatientsExams(props) {
    useEffect(function() {
        const getStudy = async () => {
            props.setOverlayVisible((count) => count + 1);

            let export_data = [];
            const items = await axios.get(
                `${BASE_API_URL}/studies/${props.match.params.id}/centers/${props.userAuth.user.center.id}/patients/`,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            // did we find the exam we were looking for?
            const found = items.data.exams.find(el => parseInt(el.id, 10) === parseInt(props.match.params.exam, 10))
            if (!found) {
                props.setOverlayVisible((count) => count - 1);
                props.history.push('/studies/');
            }

            if (items.data && items.data.centers.length) {
                items.data.centers = items.data.centers.map(center => ({
                    ...center,
                    patients: center.patients
                        .filter(p => p.status.toLowerCase() !== 'removed')
                }));
            }
            setStudy(items.data);

            if (items.data.centers.length > 0) {
                export_data = items.data.centers[0].patients.map(function(p) {
                    let _patient = {}, i;
                    const p_id = items.data.patient_identifier;

                    _patient.patient_num = p.patient_num;
                    _patient.status = p.status[0].toUpperCase() + p.status.substr(1);

                    if (p_id === null) {
                        if (p.study_left_eye && p.study_right_eye) {
                            _patient.study_eye = "Left & Right";
                        } else if (p.study_left_eye) {
                            _patient.study_eye = "Left";
                        } else if (p.study_right_eye) {
                            _patient.study_eye = "Right";
                        }
                    }

                    for (i in p.card_vars) {
                        if (
                            p.card_vars[i].var_type.uid === "patient-initials" &&
                            (p_id === null || p_id.uid !== "patient-initials")
                        ) {
                            _patient.patient_initials = p.card_vars[i].value;
                        }

                        if (
                            p.card_vars[i].var_type.uid === "randomization-number" &&
                            (p_id === null || p_id.uid !== "randomization-number")
                        ) {
                            _patient.randomization_number = p.card_vars[i].value;
                        }
                    }

                    // default fields
                    _patient.next_visit = p.next_visit || "--/--/--";
                    _patient.last_visit = p.last_visit || "--";

                    return _patient;
                });

                setExportData(export_data);
            }

            props.setOverlayVisible((count) => count - 1);
        };

        props.setNavLinks([
            { title: 'Studies', url: '/studies/', icon: 'studies' },
            { title: 'Patients', url: props.location.pathname, icon: 'pacients' }
        ]);

        localStorage.setItem('corc_study_patients_sortRandomizationNumber', "");
        localStorage.setItem('corc_study_patients_sortPatientNumber', "");
        localStorage.setItem('corc_study_patients_sortPatientInitials', "");
        localStorage.setItem('corc_study_patients_sortPatientStatus', "");
        localStorage.setItem('corc_study_patients_sortStudyEye', "");

        getStudy();
    }, []);

    const [study, setStudy] = useState({
        'id': 0,
        'status': '',
        'acronym': '',
        'full_name': '',
        'start_date': '',
        'end_date': '',
        'description': '',
        'select_patient_eye': false,
        'patient_details': '',
        'patient_identifier': null,
        'patient_card_vars': [],
        'protocol_num': '',
        'corc_num': '',
        'exams': [],
        'centers': [],
        'scheduled_visits': [],
        'technicians': [],
        'graders': [],
        'monitors': []
    });

    const [exportData, setExportData] = useState([]);

    let exportHeaders = [];

    exportHeaders.push({
        label: study.patient_identifier !== null
            ? study.patient_identifier.name
            : "Patient Number",
        key: "patient_num"
    });

    if (
        study.centers.length > 0 &&
        study.centers[0].patients.length > 0 &&
        study.centers[0].patients[0].card_vars.filter(f => f.var_type.uid === "randomization-number").length > 0 &&
        (study.patient_identifier === null || study.patient_identifier.uid !== "randomization-number")
    ) {
        exportHeaders.push({ label: "Randomization Number", key: "randomization_number" });
    }

    if (
        study.centers.length > 0 &&
        study.centers[0].patients.length > 0 &&
        study.centers[0].patients[0].card_vars.filter(f => f.var_type.uid === "patient-initials").length > 0 &&
        (study.patient_identifier === null || study.patient_identifier.uid !== "patient-initials")
    ) {
        exportHeaders.push({ label: "Patient Initials", key: "patient_initials" });
    }

    if (study.patient_identifier === null) {
        exportHeaders.push({ label: "Study Eye", key: "study_eye" });
    }

    exportHeaders.push({ label: "Last Visit", key: "last_visit" });
    exportHeaders.push({ label: "Patient Status", key: "status" });
    exportHeaders.push({ label: "Next Visit Date", key: "next_visit" });

    const exportPDF = () => {
        const marginLeft = 40;
        const title = "";
        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFontSize(15);

        const headers = [exportHeaders.map((h) => h.label)];

        const data = exportData.map(function(i) {
            let tmp = [];

            tmp.push(i.patient_num);

            if (i.randomization_number) {
                tmp.push(i.randomization_number);
            }

            if (i.patient_initials) {
                tmp.push(i.patient_initials);
            }

            if (i.study_eye) {
                tmp.push(i.study_eye);
            }

            tmp.push(i.last_visit);
            tmp.push(i.status);
            tmp.push(i.next_visit);

            return tmp;
        });

        let content = {
            startY: 50,
            head: headers,
            body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("patients-export.pdf")
    }

    const getExamName = () => {
        const found = study.exams.find(el => parseInt(el.id, 10) === parseInt(props.match.params.exam, 10))
        if (found) {
            return found.exam_type.name;
        }
        return "";
    }

    return (
        <div className="home_header_container_class wide">
            <div className="content">
                <div className="breadcrumbs">
                    <div className="path">
                        <ul>
                            <li><span className="orange text-shadow">{study.acronym ? study.acronym.toUpperCase() : ''}</span></li>
                            <li className="separator text-shadow">&gt;</li>
                            <li><span className="orange text-shadow">{getExamName()}</span></li>
                            <li className="separator text-shadow">&gt;</li>
                            <li>Patients</li>
                        </ul>
                    </div>
                    <div className="sub-menu">
                        <Link
                            to={"/studies/" + props.match.params.id + "/exams/" + props.match.params.exam + "/patients/new"}
                            className="btn normal grey right"
                        >
                            <span className="icon user-small"></span>Add patient to study
                        </Link>

                        <CSVLink className="btn normal grey right" data={exportData} headers={exportHeaders} filename={"patients-export.csv"}>
                            <span className="icon icon-list report"></span>
                            Export to CSV
                        </CSVLink>
                        <button onClick={exportPDF} className="btn normal grey right">
                            <span className="icon icon-list report"></span>Export to PDF
                        </button>
                    </div>
                </div> {/* .breadcrumbs */}

                <PatientsList
                    center={study.centers[0]}
                    study={study}
                    setStudy={setStudy}
                    params={props.match.params}
                />
            </div>
        </div>
    );
}

export default PatientsExams;

function PatientsList(props) {
    const togglePatientNumberSort = () => {
        const centers = JSON.parse(JSON.stringify(props.study.centers));
        let sort = localStorage.getItem('corc_study_patients_sortPatientNumber');

        if (sort === ">") {
            centers[0].patients.sort((a, b) => (a.patient_num.toLowerCase() < b.patient_num.toLowerCase()) ? 1 : -1)
            localStorage.setItem('corc_study_patients_sortPatientNumber', "<")
        } else {
            centers[0].patients.sort((a, b) => (a.patient_num.toLowerCase() > b.patient_num.toLowerCase()) ? 1 : -1)
            localStorage.setItem('corc_study_patients_sortPatientNumber', ">")
        }

        props.setStudy({ ...props.study, centers: centers });
    }

    const toggleRandomizationNumberSort = () => {
        const centers = JSON.parse(JSON.stringify(props.study.centers));
        let sort = localStorage.getItem('corc_study_patients_sortRandomizationNumber');

        if (sort === ">") {
            centers[0].patients.sort(function(a, b) {

                let randA = a.card_vars.find(r => {
                    return r.var_type.uid === 'randomization-number';
                });

                let randB = b.card_vars.find(r => {
                    return r.var_type.uid === 'randomization-number';
                });

                if (randA === undefined) {
                    randA = '';
                } else {
                    randA = randA.value;
                }

                if (randB === undefined) {
                    randB = '';
                } else {
                    randB = randB.value;
                }

                return (randA.toLowerCase() < randB.toLowerCase()) ? 1 : -1;
            });

            localStorage.setItem('corc_study_patients_sortRandomizationNumber', "<")
        } else {
            centers[0].patients.sort(function(a, b) {

                let randA = a.card_vars.find(r => {
                    return r.var_type.uid === 'randomization-number';
                });

                let randB = b.card_vars.find(r => {
                    return r.var_type.uid === 'randomization-number';
                });

                if (randA === undefined) {
                    randA = '';
                } else {
                    randA = randA.value;
                }

                if (randB === undefined) {
                    randB = '';
                } else {
                    randB = randB.value;
                }

                return (randA.toLowerCase() > randB.toLowerCase()) ? 1 : -1;
            });

            localStorage.setItem('corc_study_patients_sortRandomizationNumber', ">")
        }

        props.setStudy({ ...props.study, centers: centers });
    }

    const togglePatientInitialsSort = () => {
        const centers = JSON.parse(JSON.stringify(props.study.centers));
        let sort = localStorage.getItem('corc_study_patients_sortPatientInitials');

        if (sort === ">") {
            centers[0].patients.sort(function(a, b) {
                let randA = a.card_vars.find(r => {
                    return r.var_type.uid === 'patient-initials';
                });

                let randB = b.card_vars.find(r => {
                    return r.var_type.uid === 'patient-initials';
                });

                if (randA === undefined) {
                    randA = '';
                } else {
                    randA = randA.value;
                }

                if (randB === undefined) {
                    randB = '';
                } else {
                    randB = randB.value;
                }

                return (randA.toLowerCase() < randB.toLowerCase()) ? 1 : -1;
            });

            localStorage.setItem('corc_study_patients_sortPatientInitials', "<")
        } else {
            centers[0].patients.sort(function(a, b) {
                let randA = a.card_vars.find(r => {
                    return r.var_type.uid === 'patient-initials';
                });

                let randB = b.card_vars.find(r => {
                    return r.var_type.uid === 'patient-initials';
                });

                if (randA === undefined) {
                    randA = '';
                } else {
                    randA = randA.value;
                }

                if (randB === undefined) {
                    randB = '';
                } else {
                    randB = randB.value;
                }

                return (randA.toLowerCase() > randB.toLowerCase()) ? 1 : -1;
            });

            localStorage.setItem('corc_study_patients_sortPatientInitials', ">")
        }

        props.setStudy({ ...props.study, centers: centers });
    }

    const togglePatientStatusSort = () => {
        const centers = JSON.parse(JSON.stringify(props.study.centers));
        let sort = localStorage.getItem('corc_study_patients_sortPatientStatus');

        if (sort === ">") {
            centers[0].patients.sort((a, b) => (a.status.toLowerCase() < b.status.toLowerCase()) ? 1 : -1)
            localStorage.setItem('corc_study_patients_sortPatientStatus', "<")
        } else {
            centers[0].patients.sort((a, b) => (a.status.toLowerCase() > b.status.toLowerCase()) ? 1 : -1)
            localStorage.setItem('corc_study_patients_sortPatientStatus', ">")
        }

        props.setStudy({ ...props.study, centers: centers });
    }

    const toggleStudyEyeSort = () => {
        const centers = JSON.parse(JSON.stringify(props.study.centers));
        let sort = localStorage.getItem('corc_study_patients_sortStudyEye');

        if (sort === ">") {
            centers[0].patients.sort((a, b) => (a.study_left_eye === b.study_left_eye) ? 0 : a.study_right_eye ? 1 : -1);
            localStorage.setItem('corc_study_patients_sortStudyEye', "<")
        } else {
            centers[0].patients.sort((a, b) => (a.study_left_eye === b.study_left_eye) ? 0 : a.study_right_eye ? -1 : 1);
            localStorage.setItem('corc_study_patients_sortStudyEye', ">")
        }

        props.setStudy({ ...props.study, centers: centers });
    }

    return (
        <div className="visits-list list">
            <div className="list-head">
                <table>
                    <tbody>
                        <tr>
                            {
                                props.study.patient_identifier !== undefined &&
                                props.study.patient_identifier !== null
                                    ? (
                                        <th width="15%">
                                            <button onClick={() => {}}>{props.study.patient_identifier.name || ""}</button>
                                        </th>
                                    ) : (
                                        <th width="11%">
                                            <button onClick={togglePatientNumberSort}>Patient Number</button>
                                        </th>
                                    )
                            }

                            {
                                props.study.patient_card_vars.length > 0 &&
                                props.study.patient_card_vars.filter(f => f.uid === "randomization-number").length > 0 &&
                                (props.study.patient_identifier === null || props.study.patient_identifier.uid !== "randomization-number") && (
                                    <th width="15%">
                                        <button onClick={toggleRandomizationNumberSort}>Randomization Number</button>
                                    </th>
                                )
                            }

                            {
                                props.study.patient_card_vars.length > 0 &&
                                props.study.patient_card_vars.filter(f => f.uid === "patient-initials").length > 0 &&
                                (props.study.patient_identifier === null || props.study.patient_identifier.uid !== "patient-initials") && (
                                    <th width="11%">
                                        <button onClick={togglePatientInitialsSort}>Patient Initials</button>
                                    </th>
                                )
                            }

                            {
                                props.study.patient_identifier === null
                                    ? (
                                        <th width="13%">
                                            <button onClick={toggleStudyEyeSort}>Study Eye</button>
                                        </th>
                                    ) : null
                            }

                            <th width="12%">Last Visit</th>
                            <th width="14%">
                                <button onClick={togglePatientStatusSort}>Patient Status</button>
                            </th>
                            <th>Next Visit Date</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="list-body">
                <table id="list-table">
                    <tbody className="list-visits">
                        {props.center && props.center.patients.map((patient, i) => (
                            <PatientsListItem
                                study={props.study}
                                key={i}
                                patient={patient}
                                params={props.params}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function PatientsListItem(props) {
    const getPatientCardVarValue = (card_var) => {
        let patient_card_var = props.patient.card_vars.filter((f) => f.var_type.uid === card_var);

        if (patient_card_var.length) {
            return patient_card_var[0].value;
        }

        return "";
    }

    return (
        <tr className="visit">
            {
                props.study.patient_identifier !== undefined &&
                props.study.patient_identifier !== null
                    ? (
                        <td width="15%">{getPatientCardVarValue(props.study.patient_identifier.uid) || ""}</td>
                    ) : (
                        <td width="11%">{props.patient.patient_num}</td>
                    )
            }

            {
                props.study.patient_card_vars.length > 0 &&
                props.study.patient_card_vars.filter(f => f.uid === "randomization-number").length > 0 &&
                (props.study.patient_identifier === null || props.study.patient_identifier.uid !== "randomization-number") && (
                    <td width="15%">{getPatientCardVarValue("randomization-number")}</td>
                )
            }

            {
                props.study.patient_card_vars.length > 0 &&
                props.study.patient_card_vars.filter(f => f.uid === "patient-initials").length > 0 &&
                (props.study.patient_identifier === null || props.study.patient_identifier.uid !== "patient-initials") && (
                    <td width="11%">{getPatientCardVarValue("patient-initials")}</td>
                )
            }

            {
                props.study.patient_identifier === null
                    ? (
                        <td width="13%">
                            <span className={"icon min-eye" + (props.patient.study_right_eye ? '' : ' enabled')}></span>
                            <span className={"icon min-eye" + (props.patient.study_left_eye ? '' : ' enabled')}></span>
                        </td>
                    )
                    : null
            }

            <td width="12%">{props.patient.last_visit || '--'}</td>
            <td width="14%">{props.patient.status}</td>
            <td>{props.patient.next_visit || '--/--/--'}</td>
            <td className="btn-list" width="15%">
                <ul style={{ float: "right" }}>
                    <li>
                        <Link
                            to={"/studies/" + props.params.id + "/exams/" + props.params.exam + "/patients/" + props.patient.id}
                            className="btn xsmall grey"
                        >
                            <span className="icon-list user-small"></span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={"/studies/" + props.params.id + "/exams/" + props.params.exam + "/patients/" + props.patient.id + "/visits"}
                            className="btn small grey"
                        >
                            <span className="icon-list visits-small" style={{ width: "30px" }}></span>Visits
                        </Link>
                    </li>
                </ul>
            </td>
        </tr>
    );
}
